import * as React from 'react';
import UpdatePhoneVM from '@src/pages/update-phone/vm';
import VMComponent from '@src/components/vm-component';
import com from '@src/utils/com';
import cx from 'classnames';
import AccountInfo from '@src/components/account-info';
const styles = require('./index.less');

@com({ getInitialProps: UpdatePhoneVM.getInitialProps })
export default class UpdatePhone extends VMComponent(UpdatePhoneVM) {
  renderCurrentStep() {
    const { currentStep, newPhone, bindPhone } = this.vm.viewState;
    const { onSubmit, onValueChange, ongetPhoneCode } = this.vm.entry;
    switch (currentStep) {
      case 'bindNewPhone':
        return (
          <table className={styles.table} align={'center'}>
            <tbody>
              <tr>
                <td className={styles.tableLable}>
                  新绑定手机:<br />
                  <span className={styles.spanColor}>(1[3/4/5/6/7/8/9]开头)</span>
                </td>
                <td className={styles.tableInput}>
                  <input className={styles.input} maxLength="12" size={16} onChange={event => onValueChange('newPhone', event.target.value)} />
                  <span className={styles.spanColor}>*</span>
                </td>
              </tr>
              <tr>
                <td className={styles.tableLable}>
                  短信验证码:<br />
                  <span className={styles.spanColor}>(6位数字)</span>
                </td>
                <td className={styles.tableInput}>
                  <input className={styles.input} maxLength="6" size={16} onChange={event => onValueChange('code', event.target.value)} />
                  <input type="button" value="获取验证码" className={styles.inputButton} onClick={ongetPhoneCode} />
                  <span className={styles.spanColor}>*</span>
                </td>
              </tr>
              <tr>
                <td className={styles.tableSubmit} colSpan="2">
                  <input type="button" value="下 一 步" className={styles.button} maxLength="16" size={20} onClick={() => onSubmit(currentStep)} />
                </td>
              </tr>
            </tbody>
          </table>
        );
      case 'verifyOldPhone':
        return (
          <div className={styles.verityOld}>
            <div className={styles.verityText}>
              <p>
                新绑定手机号：<span>{newPhone}</span>
              </p>
              <p>已向原绑定手机{bindPhone}发送验证短信，请仔细确认并回复短信，谢谢！</p>
              <p>回复短信后,请点击“我已发送”，完成修改</p>
              <div className={styles.inputText}>
                <input type="button" value="我已发送" className={styles.sendButton} maxLength="16" size={20} onClick={() => onSubmit(currentStep)} />
              </div>
            </div>
            <div className={styles.warnText}>
              <p>
                温馨提示：若您无法验证原绑定手机，请向客服申请【<span>GM修改绑定手机</span>】业务。
              </p>
              <p>(仅针对端游，手游用户请联系“游戏在线客服”咨询。)</p>
            </div>
          </div>
        );
      case 'complete':
        return (
          <div className={styles.complete}>
            <p>修改成功！</p>
            <p>您目前绑定手机号是{newPhone}</p>
          </div>
        );
      default:
        return null;
    }
  }
  render() {
    const vm = this.vm;
    const { entry, viewState, computes } = vm;
    const { stepperRebind, currentStep, account } = viewState;
    const { onExitClick, onLoginClick } = entry;
    return (
      <div className={styles.root}>
        <div className={styles.stepperGroup}>
          <span className={styles.tipSpan}>······</span>
          {stepperRebind.map((item, index) => {
            return (
              <div className={cx(styles.step, currentStep === item.key && styles.stepActive)} key={index}>
                {item.title}
                <span className={cx(styles.tipSpan, item.key === 'complete' && styles.hidden)}>···>···</span>
              </div>
            );
          })}
          <span className={styles.tipSpan}>······</span>

          <div className={styles.info}>
            <AccountInfo username={account} onLogoutClick={onExitClick} onLoginClick={onLoginClick} />
          </div>
        </div>
        <div className={styles.currentStepper}>{this.renderCurrentStep()}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/update-phone/index.js